/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */
(function () {
    'use strict';
    angular.module('vcexamtemplate')
      .component('examtemplateform', {
        restrict: 'E',
        bindings: {
          examtemplate: '<',
          parentsave: '&',
          oncancel: '&'
        },
        templateUrl: 'vcexamtemplate/examtemplateform-component.tpl.html',
        controllerAs: 'vm',
        controller: ['$log', '$timeout', 'Config', 'Share',
          function ($log, $timeout, Config, Share) {
            let vm = this;
            vm.save = save;
            vm.cancel = cancel;
            vm.newSubItem = newSubItem;
            vm.newFieldGroup = newFieldGroup;
            vm.remove = remove;
            vm.addNamedField = addNamedField;
            vm.removeNamedField = removeNamedField;
            vm.toggle = toggle;
            vm.showFGN = showFGN;
            vm.hideFGN = hideFGN;
            vm.addCatItem = addCatItem;
            vm.addCatGroup = addCatGroup;
            vm.removeCatItem = removeCatItem;
            vm.removeCatGroup = removeCatGroup;
            vm.addTracker = addTracker;
            vm.removeTracker = removeTracker;

            vm.modalitypes = [];
            vm.modalitypes.push({type: 'US', text: 'Ultraschall'});
            vm.modalitypes.push({type: 'CD', text: 'Color flow doppler'});
            vm.modalitypes.push({type: 'DD', text: 'Duplex Doppler'});
            vm.modalitypes.push({type: 'CR', text: 'Computergeschützte Radiologie'});
            vm.modalitypes.push({type: 'XR', text: 'Digitale Radiographie'});
            vm.modalitypes.push({type: 'XR', text: 'Intraorale Radiographie'});
            vm.modalitypes.push({type: 'CT', text: 'Coputertomographie'});
            vm.modalitypes.push({type: 'MR', text: 'Magnetresonanztomographie'});
            vm.modalitypes.push({type: 'ES', text: 'Endoskopie'});
            vm.modalitypes.push({type: 'AU', text: 'Audio ECG'});

            /*        Complete list of allowed dicom modality tytpes
                      CR 	Computed Radiography
                      CT 	Computed Tomography
                      MR 	Magnetic Resonance
                      US 	Ultrasound
                      OT 	Other
                      BI 	Biomagnetic imaging
                      CD 	Color flow Doppler
                      DD 	Duplex Doppler
                      DG 	Diaphanography
                      ES 	Endoscopy
                      LS 	Laser surface scan
                      PT 	Positron emission tomography (PET)
                      RG 	Radiographic imaging (conventional film/screen)
                      ST 	Single-photon emission computed tomography (SPECT)
                      TG 	Thermography
                      XA 	X-Ray Angiography
                      RF 	Radio Fluoroscopy
                      RTIMAGE 	Radiotherapy Image
                      RTDOSE 	Radiotherapy Dose
                      RTSTRUCT 	Radiotherapy Structure Set
                      RTPLAN 	Radiotherapy Plan
                      RTRECORD 	RT Treatment Record
                      HC 	Hard Copy
                      DX 	Digital Radiography
                      NM 	Nuclear Medicine
                      MG 	Mammography
                      IO 	Intra-oral Radiography
                      PX 	Panoramic X-Ray
                      GM 	General Microscopy
                      SM 	Slide Microscopy
                      XC 	External-camera Photography
                      PR 	Presentation State
                      AU 	Audio ECG
                      EPS 	Cardiac Electrophysiology
                      HD 	Hemodynamic Waveform
                      SR 	SR Document
                      IVUS 	Intravascular Ultrasound
                      OP 	Ophthalmic Photography
                      SMR 	Stereometric Relationship*/

            vm.$onInit = function () {
              vm.fgnshow = [];
              vm.lastexamtemplate = angular.copy(vm.examtemplate);


              Config.$find('dicomaetitle').$then(function (dicomaetitle) {
                vm.dicomaetitle = dicomaetitle;
                // intialize if still empty
                if (angular.isUndefined(vm.dicomaetitle.dicomaetitle)) {
                  vm.dicomerror = `Es wurden keine DICOM Geräte konfiguriert: Menü Einstellungen -> Dicom `;
                }
              });


              Config.$find('gdtsoftware').$then(function (gdtsoftware) {
                vm.gdtsoftware = gdtsoftware;
                // intialize if still empty
                if (angular.isUndefined(vm.gdtsoftware.gdtsoftware)) {
                  vm.gdtswerror = `Es wurden keine GDT Software konfiguriert: Menü Einstellungen -> GDT Software `;
                }
              });


              Config.$find('gdtprofil').$then(function (gdtprofil) {
                vm.gdtprofil = gdtprofil;
                // intialize if still empty
                if (angular.isUndefined(vm.gdtprofil.gdtprofil)) {
                  vm.gdtperror = `Es wurde kein GDT Profil konfiguriert: Menü Einstellungen -> GDT Profile `;
                }
              });


              Share.$search().$then(shares => {
                if (shares.length === 0) {
                  vm.shareserror = `Es wurden keine Netzlaufwerke konfiguriert: Menü Einstellungen -> Netzlaufwerke / GDT `;
                }
                vm.allshares = shares;
                vm.gdtshares = shares.filter(share => angular.isDefined(share.sharetype) && share.sharetype === 'gdt');
                if (vm.gdtshares.length === 0) {
                  vm.gdtswerror = `Es wurde keine GDT Software konfiguriert: Menü Einstellungen -> Netzlaufwerke / GDT `;
                }
              })

            };

            function save() {
              if (!angular.equals(vm.examtemplate, vm.lastexamtemplate)) {
                vm.lastexamtemplate = angular.copy(vm.examtemplate);
                vm.parentsave({examtemplate: vm.examtemplate});
              }
            }

            function cancel() {
              vm.examtemplate = angular.copy(vm.lastexamtemplate);
              vm.oncancel();
            }

            function showFGN(index) {
              vm.fgnshow[index] = true;
            }

            function hideFGN(index) {
              vm.fgnshow[index] = false;
            }

            function newFieldGroup() {
              if (angular.isUndefined(vm.examtemplate.template.fieldgroups) || !angular.isArray(vm.examtemplate.template.fieldgroups)) {
                vm.examtemplate.template.fieldgroups = [];
              }
              vm.examtemplate.template.fieldgroups.push({
                label: 'Neue Feldgruppe',
                fields: [{
                  label: 'Neues Feld',
                  avalues: [],
                  values: []
                }]
              });
            }

            function newSubItem(scope) {
              let nodeData = scope.$modelValue;
              if (angular.isUndefined(nodeData.fields) || !angular.isArray(nodeData.fields)) {
                nodeData.fields = [];
              }
              nodeData.fields.push({
                label: 'Neues Feld',
                avalues: [],
                values: []
              });
            }

            function remove(scope) {
              scope.remove();
              $timeout(function () {
                vm.examtemplate.$save();
              }, 500);
              // vm.examtemplate.$save();
            }

            function addNamedField(type) {
              let labels = {
                comment: 'Kommentar',
                biopsy: 'Biopsie',
                recommendation: 'Empfehlung',
                diagnosis: 'Zusammenfassung'
              };
              let biopsy = {
                label: '',
                avalues: [],
                values: []
              };
              vm.examtemplate.template[type] = {
                label: labels[type],
                avalues: [],
                values: []
              };
              if (type === 'biopsy') {
                vm.examtemplate.template[type].biopsies = [];
                vm.examtemplate.template[type].biopsies.push(biopsy);
              }
              vm.examtemplate.$save();
            }

            function removeNamedField(type) {
              delete vm.examtemplate.template[type];
              vm.examtemplate.$save();
            }

            function toggle(scope) {
              scope.toggle();
            }

            // search can return both item or group
            function addCatItem(privcat, privcatref) {
              if (privcat.type === 'entry') {
                checkServiceStructure();
                delete privcat.price;
                delete privcat.price;
                vm.examtemplate.template.services.items.push(privcat);
              } else {
                addCatGroup(privcat, privcatref);
              }
            }

            // group picker always returns group
            function addCatGroup(privcat, privcatref) {
              checkServiceStructure();
              vm.examtemplate.template.services.groups.push(privcat);
            }

            function removeCatItem(index) {
              vm.examtemplate.template.services.items.splice(index, 1);
            }

            function removeCatGroup(index) {
              vm.examtemplate.template.services.groups.splice(index, 1);
            }

            function checkServiceStructure() {
              if (angular.isUndefined(vm.examtemplate.template.services)) {
                vm.examtemplate.template.services = {};
                vm.examtemplate.template.services.items = [];
                vm.examtemplate.template.services.groups = [];
              }
            }


            function addTracker(tracker) {
              if (angular.isUndefined(vm.examtemplate.template.trackers)) {
                vm.examtemplate.template.trackers = [];
              }
              vm.examtemplate.template.trackers.push(tracker);
            }

            function removeTracker(index) {
              vm.examtemplate.template.trackers.splice(index, 1);
            }

            vm.sprlayout = `Sie können zwischen spalten- und zeilenorientiertem Layout wählen. 
             Das spaltenorientierte Layout eignet sich für Befunde die ein kurzes Schlagwort (z.B. "Leber") 
             mit längeren Ausführungen kombinieren. Das zeilenorientierte Layout eignet sich, wenn Sie längere 
             Erklärungstexte (z.B. Patientenfragebögen) mit kurzen oder auch längeren Antworten abbilden möchten. 
             Sie können das Layout jederzeit umstellen, die Änderung wirkt sich allerdings nur auf die 
             nachfolgenden Aufrufe aus.`;


          }] // controller
      }); // component

// klammerfriedhof
  }
  ()
)
;